import pro1 from "../Assets/flight.png"
import pro2 from "../Assets/weather.png"
import pro3 from "../Assets/car.png"
import pro4 from "../Assets/js game.png"
import pro5 from "../Assets/todo.png"
import pro6 from "../Assets/dashboard.png"

const ProjectCardData = [
    {
        imgsrc:pro1,
        title:"Flight Search App",
        text:"A React Project that you can search and filter static flight data.",
        view:"https://chic-toffee-028ed3.netlify.app/",
        source:"https://github.com/BerkTenk/Flight-Search-App/tree/main/flight-search-app"

    },
    {
        imgsrc:pro2,
        title:"Weather App",
        text:"A React project that you can view the 5-day weather forecast of a province in Turkey ",
        view:"https://celebrated-figolla-a30525.netlify.app/",
        source:"https://github.com/BerkTenk/patika/tree/main/React/Weather%20App/weather"
        
    },
    {
        imgsrc:pro3,
        title:"Car Gallery App",
        text:"A React project that you can view cars and their datas with different methods.",
        view:"https://velvety-unicorn-426f65.netlify.app/",
        source:"https://github.com/BerkTenk/car-gallery-app"
    },
    {
        imgsrc:pro4,
        title:"Basic HTML/JavaScript Game",
        text:"Basic game that made with JavaScript.Use W and S to move and spacebar to shoot. Thats it. ",
        view:"https://stupendous-narwhal-b0e842.netlify.app/",
        source:"https://github.com/BerkTenk/HTML-JavaScript-Game"
    },
    {
        imgsrc:pro5,
        title:"Todo List App",
        text:"A React project that you can list your tasks.",
        view:"https://todo-list-app-byberktenk.netlify.app/",
        source:"https://github.com/BerkTenk/to-do-list-app"
    },
    {
        imgsrc:pro6,
        title:"Cryptocurrency Dashboard App",
        text:"This project is a cryptocurrency dashboard built with React, Bootstrap, Chart.js, and Axios. It allows users to select different cryptocurrencies and view their price trends over a specified number of days using various chart types.",
        view:"https://dashboard-berktenk.netlify.app/",
        source:"https://github.com/BerkTenk/dashboard-data-app"
    }
]

export default ProjectCardData;